<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-card class="elevation-2 mt-5 mb-8">
            <v-card-title class="flex-nowrap">
                {{ $t('Calendario de agendamiento') }}
            </v-card-title>
            <v-card-text>
                <v-btn
                    color="primary"
                    outlined
                    type="button"
                    class="text-capitalize mr-2"
                    @click="dialogCalendar = true"
                >
                    <v-icon>mdi-calendar</v-icon>
                    {{ $t('Ver calendario') }}
                </v-btn>
            </v-card-text>
        </v-card>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                {{ $t('Lista de Agendamiento') }}
                <v-spacer></v-spacer>
                <v-btn @click="scroll_left" fab small>
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn @click="scroll_right" fab small>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            #
                        </th>
                        <th class="text-left">
                            {{ $t('Acciones') }}
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Estado') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='state', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='state', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtState"
                                                    :items="itemsStatus"
                                                    item-text="label"
                                                    item-value="val"
                                                    label="Estados"
                                                    multiple
                                                    chips
                                                    outlined
                                                    hide-details
                                                    dense
                                                >
                                                    <template v-slot:selection="data">
                                                        <v-chip
                                                            :color="data.item.color"
                                                            small
                                                            class="white--text"
                                                        >
                                                            {{ data.item.label }}
                                                        </v-chip>
                                                    </template>
                                                </v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('state')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:150px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Fecha y hora') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='day', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='day', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtFecha"
                                                    label="Fecha"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="date"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('fecha')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Cliente') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='full_name', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='full_name', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSearch"
                                                    label="Cliente"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txt')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Celular') }}       </span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='phone_number', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='phone_number', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtPhone"
                                                    label="Celular"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('phone')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-right blue-grey lighten-4">
                            <div class="d-flex align-center">
                                <span>{{ $t('Inmueble') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='product.name', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='product.name', getListRealStates()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtProduct"
                                                    label="Inmueble"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('product')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listOrders" :key="index">
                        <td>{{ item.number }}</td>
                        <td>
                            <div class="d-flex">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            @click="openComments(item.id, item.agent_comment)"
                                        >
                                            <v-icon color="grey">
                                                mdi-comment-text-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('Comentarios') }}</span>
                                </v-tooltip>
                            </div>
                        </td>
                        <td>
                            <v-select
                                :items="itemsStates"
                                label="Estado"
                                outlined
                                dense
                                hide-details
                                v-model="item.state"
                                @change="updateState(item.state, item.id)"
                            >
                                <template v-slot:selection="data">
                                    <span :class="{
                                        'yellow--text text--darken-4': data.item=='Pendiente',
                                        'green--text': data.item=='Agendado',
                                        'red--text': data.item=='Caído',
                                    }">
                                        {{ data.item }}
                                    </span>
                                </template>
                            </v-select>
                        </td>
                        <td>{{ item.date }} - {{ item.time }}</td>
                        <td>{{ item.full_name }}</td>
                        <td>{{ item.phone_number }}</td>
                        <td class="blue-grey lighten-4 text-right py-2">
                            <a :href="`/${slug}?product=${item.product?.id}`" target="_blank">
                                {{ item.product?.name }}
                            </a>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

        <!-- dialog calendar -->
        <v-dialog
            v-model="dialogCalendar"
            max-width="1400"
        >
            <v-card>
                <v-card-title class="text-h5">
                    {{ $t('Calendario de agendamiento') }}
                </v-card-title>
                <v-card-text>
                    <calendar-real_states
                        v-if="dialogCalendar"
                        @update-calendar="getListRealStates"
                        :locale="locale"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogCalendar = false"
                    >
                        {{ $t('Cerrar') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog calendar -->

        <!-- dialog comments -->
        <v-dialog
            v-model="dialogComments"
            max-width="600"
        >
            <v-card>
                <v-card-title class="text-h5">
                    {{ $t('Comentarios') }}
                </v-card-title>
                <v-card-text>
                    <v-textarea
                        v-model="comment"
                        :label="$t('Comentarios')"
                        outlined
                        dense
                        hide-details
                        :disabled="loading2"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogComments = false"
                        :disabled="loading2"
                    >
                        {{ $t('Cerrar') }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        :loading="loading2"
                        @click="saveComments"
                    >
                        {{ $t('Guardar') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog comments -->
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            loading2: false,
            dialogComments: false,
            idComments: null,
            comment: '',
            breadcrumbs: [
                {
                    text: 'Agendamiento',
                    disabled: false,
                    href: '/admin/real_states',
                },
                {
                    text: 'Todas',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'http://'+window.location.hostname+'/',
            dialogCalendar: false,
            // list data
            itemsStatus: [
                {label: 'Pendiente', val: 'Pendiente', color: 'yellow darken-4'},
                {label: 'Agendado', val: 'Agendado', color: 'success'},
                {label: 'Caído', val: 'Caído', color: 'error'},
            ],
            txtState: [],
            listOrders: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
            txtNumber: '',
            txtPhone: '',
            txtFecha: '',
            txtProduct: '',
            // actualizar estados
            itemsStates: ['Pendiente', 'Agendado', 'Caído'],
            // export
            menuInit: false,
            menuEnd: false,
            dateInit: '',
            dateEnd: '',
            orderType: 'DESC',
            orderBy: 'created_at'
        }
    },
    props: ['money', 'slug', 'locale'],
    mounted() {
        this.getListRealStates()
    },
    methods: {
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListRealStates()
        },
        changePage (event) {
            this.page = event;
            this.getListRealStates()
        },
        cleanSearch (type='') {
            if (type=='') {
                if ( (this.txtSearch !== '') || (this.dateInit!='') || (this.dateEnd!='') ) {
                    this.listOrders = []
                    this.page = 1
                    this.txtSearch = ''
                    this.dateInit = ''
                    this.dateEnd = ''
                    this.getListRealStates();
                }
            } else {
                switch (type) {
                    case 'txt':
                        this.txtSearch = ''
                        this.getListRealStates();
                        break;
                    case 'phone':
                        this.txtPhone = ''
                        this.getListRealStates();
                        break;
                    case 'number':
                        this.txtNumber = ''
                        this.getListRealStates();
                        break;
                    case 'fecha':
                        this.txtFecha = ''
                        this.getListRealStates();
                        break;
                    case 'state':
                        this.txtState = []
                        this.getListRealStates();
                        break;
                    case 'product':
                        this.txtProduct = ''
                        this.getListRealStates();
                        break;
                    default:
                        break;
                }
            }
        },
        async getListRealStates () {
            this.listOrders = []
            this.overlay = true
            await axios.post(`/admin/list-real_states?page=${this.page}
                            &orderby=${this.orderBy}
                            &ordertype=${this.orderType}
                            &search=${this.txtSearch}
                            &date_init=${this.dateInit}
                            &date_end=${this.dateEnd}
                            &number=${this.txtNumber}
                            &phone=${this.txtPhone}
                            &fecha=${this.txtFecha}
                            &product=${this.txtProduct}
                            &states=${JSON.stringify(this.txtState)}
            `, {})
            .then(response => {
                // console.log(response)
                response.data.data.forEach(element => {
                    const d = new Date(element.day)
                    element.date = (d.getDate()+1) +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear()
                    this.listOrders.push(element)
                });
                // this.listOrders = response.data[0].data
                this.totalPage = response.data.last_page
                this.pageTable = `${this.$t('Mostrando')} <strong>${response.data.from??0} - ${response.data.to??0}</strong> ${this.$t('de un total de')} <strong>${response.data.total}</strong>`

                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.overlay = false
            })
        },
        /**
         * scroll
         */
        scroll_left() {
        let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft -= 100;
        },
        scroll_right() {
            let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft += 100;
        },
        /**
         * update state
         */
        async updateState(val, id) {
            this.loading = true
            await axios.post(`/admin/up-real-state/${id}`, {state: val})
            .then((response) => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('Estado actualizado con éxito.'))
                }
                this.loading = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.loading = false
            });
        },
        openComments(id, comments) {
            this.dialogComments = true
            this.idComments = id
            this.comment = comments
        },
        async saveComments() {
            this.loading2 = true
            await axios.post(`/admin/up-real-state/${this.idComments}`, {agent_comment: this.comment})
            .then((response) => {
                this.dialogComments = false
                this.loading2 = false
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('Comentario actualizado con éxito.'))
                    this.getListRealStates()
                }
            })
            .catch((error) => {
                this.loading2 = false
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.loading2 = false
            });
        },
    },
}
</script>
